<template>
  <div>
    <Header>
      <template v-slot:left>
        <FeatherIcon icon="chevron-left" @click="onClickBack" />
      </template>
      アカウント情報
    </Header>
    <div class="mypage py-3">
      <div class="section px-3 pt-4 mt-2">
        <div class="bg-white border border-outline-color px-3 mt-1 round-4">
          <RouterLink
            :to="{ name: 'EditPhoneNumber' }"
            class="d-flex justify-content-between align-items-center py-3"
          >
            <p class="text-size-14">電話番号変更</p>
            <div class="d-flex justify-content-end align-items-center">
              <FeatherIcon
                icon="chevron-right"
                size="1x"
                class="text-gray-05 ml-2"
              />
            </div>
          </RouterLink>
          <RouterLink
            :to="{ name: 'ResetPassword' }"
            class="d-flex justify-content-between align-items-center border-top border-outline-color py-3"
          >
            <p class="text-size-14">パスワード変更</p>
            <div class="d-flex justify-content-end align-items-center">
              <FeatherIcon
                icon="chevron-right"
                size="1x"
                class="text-gray-05 ml-2"
              />
            </div>
          </RouterLink>
          <RouterLink
            :to="{ name: 'Withholding' }"
            class="d-flex justify-content-between align-items-center border-top border-outline-color py-3"
          >
            <p class="text-size-14">源泉徴収票の発行</p>
            <div class="d-flex justify-content-end align-items-center">
              <FeatherIcon
                icon="chevron-right"
                size="1x"
                class="text-gray-05 ml-2"
              />
            </div>
          </RouterLink>
          <RouterLink
            :to="{ name: 'MypageNotification' }"
            class="d-flex justify-content-between align-items-center border-top border-outline-color py-3"
          >
            <p class="text-size-14">メール・プッシュ通知受信設定</p>
            <div class="d-flex justify-content-end align-items-center">
              <FeatherIcon
                icon="chevron-right"
                size="1x"
                class="text-gray-05 ml-2"
              />
            </div>
          </RouterLink>
          <RouterLink
            v-if="isShownSetWorkerService"
            :to="{ name: 'SetWorkerService' }"
            class="d-flex justify-content-between align-items-center border-top border-outline-color py-3"
          >
            <p class="text-size-14">業務カテゴリ設定</p>
            <div class="d-flex justify-content-end align-items-center">
              <FeatherIcon
                icon="chevron-right"
                size="1x"
                class="text-gray-05 ml-2"
              />
            </div>
          </RouterLink>
          <RouterLink
            :to="{ name: 'MuteList' }"
            class="d-flex justify-content-between align-items-center border-top border-outline-color py-3"
          >
            <p class="text-size-14">事業所ミュート設定</p>
            <div class="d-flex justify-content-end align-items-center">
              <FeatherIcon
                icon="chevron-right"
                size="1x"
                class="text-gray-05 ml-2"
              />
            </div>
          </RouterLink>
          <RouterLink
            :to="{ name: 'EditEmergencyContactOfRelationship' }"
            class="d-flex justify-content-between align-items-center border-top border-outline-color py-3"
          >
            <p class="text-size-14">緊急連絡先</p>
            <div class="d-flex justify-content-end align-items-center">
              <FeatherIcon
                icon="chevron-right"
                size="1x"
                class="text-gray-05 ml-2"
              />
            </div>
          </RouterLink>
          <RouterLink
            :to="{ name: 'OtherAccountInfo' }"
            class="d-flex justify-content-between align-items-center border-top border-outline-color py-3"
          >
            <p class="text-size-14">その他</p>
            <div class="d-flex justify-content-end align-items-center">
              <FeatherIcon
                icon="chevron-right"
                size="1x"
                class="text-gray-05 ml-2"
              />
            </div>
          </RouterLink>
        </div>
      </div>
      <AppFooter />
      <BlockBack />
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-facing-decorator";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import Header from "@/components/organisms/common/Header.vue";
import AppFooter from "@/components/organisms/common/AppFooter.vue";
import BlockBack from "@/components/organisms/common/BlockBack.vue";
import { sendAdjustEvent } from "@/plugins/adjust";
import { sendFirebaseCustomEvent } from "@/plugins/firebase";
import { authStore } from "@/store/auth";
import { routerPush } from "@/utils/routerPush";

@Component({
  components: {
    FeatherIcon,
    Header,
    AppFooter,
    BlockBack
  }
})
export default class AccountInfo extends Vue {
  get isShownSetWorkerService() {
    return authStore.product.workerServices.length >= 2;
  }

  async created() {
    await sendAdjustEvent("SHOW_ACCOUNT_INFO");
    sendFirebaseCustomEvent("show_account_info", {
      username: authStore.user?.username || "unknown"
    });
  }

  async onClickBack() {
    await routerPush(this, { name: "Mypage" });
  }
}
</script>

<style lang="scss" scoped>
.mypage {
  position: relative;

  .section {
    // iPhone のノッチ対応
    padding-top: env(safe-area-inset-top, 0);
  }
}
</style>
